import { AxiosResponse } from "axios";
import api, { errorHandler } from "src/util/api";
import { ReqUserInfo, ResUserInfo } from "./types";

export const getUserInfo = async (req?: ReqUserInfo): Promise<AxiosResponse<ResUserInfo>> => {
    return await errorHandler(api.get('/user'))
}